module.exports = __webpack_public_path__ + "static/media/D_Q.def633f2.png";